import { Component } from '@angular/core';

@Component({
    selector: 'sec-ioc',
    template: `<sec-header></sec-header>
    <sec-alert></sec-alert>
    <sec-body></sec-body>
    <sec-footer></sec-footer>`
})
export class AppComponent {}
